import React, { useCallback, useEffect } from "react";
import { Dropdown, Drawer } from "antd";
import { useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Tooltip, Progress } from "antd";
import { Slide } from "react-slideshow-image";
import FeatherIcon from "feather-icons-react";
import "react-slideshow-image/dist/styles.css";
import translate from "../../../../shared/utils/translations";
import OutsideAlerter from "../../../../shared/header/_useOutsideAlerter";
import MarketComparison from "./_market_comparsion";
import KepickerCalculator from "./_kepicker_calculator";
import DimensionsInfos from "./_dimensions_infos";
import RoiFees from "./_roi_fees";
import MainInfos from "./_main_infos";
import StockFetcher from "./_stock_fetcher";
import AdditionalInfos from "./_additional_infos";
import KeepaData from "./_keepa_data";
import AsinFetcher from "./_asin_fetcher";
import { useParams } from "react-router-dom";
import {
  copyToClipboard,
  requestHandler,
  makeReadable,
  waitSeconds,
} from "../../../../shared/utils/helpers";
import NoImage from "../../../../../assets/img/no_image.png";
import LoaderPage from "../../../../common/loaders/loader_page";
import LoaderPBI from "../../../../common/loaders/loader_pbi";

const PBIPage = ({ setPage }) => {
  useEffect(() => {
    setPage("dashboard-client");
    localStorage.setItem("dashboard-type", "dashboard-client");
  });
  const { asin } = useParams();

  const [isMore, setMore] = useState(false);
  const [isTab, setTab] = useState("mc");
  const [isAsinFetcher, setAsinFetcher] = useState(false);
  const [keepaData, setKeepaData] = useState({});
  const [additionalData, setAdditionalData] = useState({});
  const [baseOffersData, setBaseOffersData] = useState({});
  const [targetOffersData, setTargetOffersData] = useState({});
  const [imageUrl, setImageUrl] = useState("");
  const [mainData, setMainData] = useState({});
  const [basePrice, setBasePrice] = useState(0);
  const [basePriceNotConverted, setBasePriceNotConverted] = useState(0);
  const [targetPrice, setTargetPrice] = useState(0);
  const [shippingCost, setShippingCost] = useState(0);
  const [preferenceData, setPreferenceData] = useState({});

  const getPostfixFromUrl = (url) => {
    "https://www.amazon.co.uk/dp/B01HB2DCT0";
    //extract .co.uk
    let linkPostFix = url?.replace("https://www.amazon", "");
    //remove /dp...
    linkPostFix = linkPostFix?.substring(0, linkPostFix.indexOf("/dp"));
    return linkPostFix;
  };
  const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(isNaN(value) ? 0 : value);
      }, delay);

      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);

    return debouncedValue;
  };

  const getData = async () => {
    const res = await requestHandler(
      "post",
      `/sp-api/roi`,
      { asin },
      true,
      null,
      null
    );
    setKeepaData(res?.data?.keepaData);
    setAdditionalData(res?.data?.additionalData);
    setBaseOffersData(res?.data?.baseOffers);
    setTargetOffersData(res?.data?.targetOffers);
    setMainData(res?.data);
    setBasePrice(parseFloat(res?.data?.baseDomainPrice));
    setTargetPrice(parseFloat(res?.data?.targetOffers?.price));
    setShippingCost(parseFloat(res?.data?.shippingCost));
    setImageUrl(res?.data?.image_url);
    setPreferenceData(res?.data?.preference);
    setBasePriceNotConverted(parseFloat(res?.data?.baseDomainPriceMain));
  };

  const manualCalculate = async () => {
    const res = await requestHandler(
      "post",
      `/sp-api/roiManual`,
      {
        asin,
        basePrice,
        targetPrice,
        shippingCost,
        monthlyStorageFee: mainData?.monthlyStorageFee,
        weight: mainData?.weight,
      },
      true,
      null,
      null
    );
    setMainData(res?.data);
    setBasePrice(res?.data?.baseDomainPrice);
    setTargetPrice(res?.data?.targetDomainPrice);
    setShippingCost(res?.data?.shippingCost);
  };
  const manualCalculateOnBaseCurrency = async () => {
    const res = await requestHandler(
      "post",
      `/sp-api/roiManual`,
      {
        asin,
        basePrice,
        basePriceNotConverted,
        targetPrice,
        shippingCost,
        monthlyStorageFee: mainData?.monthlyStorageFee,
        weight: mainData?.weight,
      },
      true,
      null,
      null
    );
    setMainData(res?.data);
    setBasePrice(res?.data?.baseDomainPrice);
    setTargetPrice(res?.data?.targetDomainPrice);
    setShippingCost(res?.data?.shippingCost);
  };
  useEffect(() => {
    getData();
  }, []);
  const debouncedBasePrice = useDebounce(basePrice, 500); // 500 ms delay
  const debouncedTargetPrice = useDebounce(targetPrice, 500);
  const debouncedShippingCost = useDebounce(shippingCost, 500);
  const debouncedBasePriceNotConverted = useDebounce(
    basePriceNotConverted,
    500
  );
  useEffect(() => {
    if (
      debouncedBasePrice &&
      debouncedTargetPrice &&
      debouncedShippingCost &&
      (debouncedBasePrice !== parseFloat(mainData?.baseDomainPrice) ||
        debouncedTargetPrice !== parseFloat(targetOffersData?.price) ||
        debouncedShippingCost !== parseFloat(mainData?.shippingCost))
    ) {
      console.log("manualCalculate called");

      manualCalculate();
    }
  }, [debouncedBasePrice, debouncedTargetPrice, debouncedShippingCost]);

  useEffect(() => {
    console.log(
      "debouncedBasePriceNotConverted",
      debouncedBasePriceNotConverted
    );
    console.log("baseOffersData?.price", baseOffersData?.price);
    if (
      debouncedBasePriceNotConverted &&
      debouncedTargetPrice &&
      debouncedShippingCost &&
      baseOffersData?.price &&
      debouncedBasePriceNotConverted > 0 &&
      parseFloat(debouncedBasePriceNotConverted) !==
        parseFloat(baseOffersData?.price)
    ) {
      console.log("manualCalculateOnBaseCurrency called");
      //manualCalculateOnBaseCurrency();
    }
  }, [debouncedBasePriceNotConverted]);

  return (
    <>
      <div className="outer__inner">
        <div className="onex_wl bg_white">
          <div className="onex_wl__wrapper ppbbi">
            <div className="onex_wl__list pbbi__body ps_rrel">
              {!mainData?.asin ? <LoaderPBI /> : <></>}

              <div className="cmp_drw_title">
                <h4>{translate("Product Based Info")}</h4>{" "}
                <div className="rght_itms">
                  <div className="prdct__Tags">
                    {keepaData?.variationCount > 0 && (
                      <Tooltip
                        title={translate("Variation Product - Variation Count")}
                        placement="bottom"
                      >
                        <div className="pb_icn_info">
                          <img src={"/assets/img/icons8-variation-50.png"} />
                          <span className="vari__bulp">
                            {keepaData?.variationCount}
                          </span>
                        </div>
                      </Tooltip>
                    )}

                    {additionalData?.is_meltable && (
                      <Tooltip
                        title={translate("Heat Sensitive - Meltable")}
                        placement="bottom"
                      >
                        <div className="pb_icn_info">
                          <img
                            className="tt"
                            src="/assets/img/icons8-heat-48.png"
                          />
                        </div>
                      </Tooltip>
                    )}
                    {additionalData?.is_hazmat && (
                      <Tooltip title={translate("Hazmat")} placement="bottom">
                        <div className="pb_icn_info">
                          <img src="/assets/img/icons8-skull-64.png" />

                          <div className="hover_card_details">
                            <div>
                              <ul>
                                $
                                {additionalData?.hazmat_data
                                  ?.filter((i) => i["aspect"] != "exception")
                                  .map((i) => {
                                    delete i["marketplace_id"];
                                    return `<li>${makeReadable(i["aspect"])}: ${
                                      i["value"]
                                    }</li>`;
                                  })
                                  .join("")}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </Tooltip>
                    )}
                  </div>

                  <Tooltip title={translate("Re-calculate")} placement="left">
                    <button
                      onClick={() => {
                        setMainData({});
                        getData();
                      }}
                      className="button-stroke button-small activity__button js-activity-button cc icn"
                    >
                      <span>
                        <FeatherIcon icon={"refresh-ccw"} />
                      </span>
                    </button>
                  </Tooltip>

                  <OutsideAlerter setMore={setMore}>
                    <div className={`select-menu__kkp ${isMore && " active"}`}>
                      <Tooltip title={translate("More")} placement="left">
                        <button
                          onClick={() => setMore(!isMore)}
                          className="button-stroke button-small activity__button js-activity-button cc icn"
                        >
                          <span>
                            <FeatherIcon icon={"more-horizontal"} />
                          </span>
                        </button>
                      </Tooltip>

                      <ul className="options__kkp">
                        <li className="option__kkp">
                          <a
                            href={`https://www.google.com/search?q=${additionalData?.title
                              ?.trim()
                              .replace(/\s/g, "+")}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img src="/assets/img/icons8-google-96.png"></img>
                            <span className="option-text">
                              {translate("Search on Google")}
                            </span>
                          </a>
                        </li>
                        <li className="option__kkp">
                          <a
                            href={`https://sellercentral.amazon${getPostfixFromUrl(
                              mainData?.product_link
                            )}/hz/approvalrequest/restrictions/approve?asin=${asin}`}
                            target="_blank"
                          >
                            <img src="/assets/img/icons8-amazon-96.png"></img>
                            <span className="option-text">
                              {translate("Check on Amazon Seller Central")}
                            </span>
                          </a>
                        </li>

                        <div className="dividerr_tt"></div>

                        <li
                          className="option__kkp"
                          onClick={() => copyToClipboard(asin)}
                        >
                          <FeatherIcon icon={"copy"} />
                          <small>ASIN</small>
                          <span className="option-text">{asin}</span>
                        </li>
                        <li
                          className="option__kkp"
                          onClick={() =>
                            copyToClipboard(keepaData?.ean?.join(","))
                          }
                        >
                          <FeatherIcon icon={"copy"} />
                          <small>EAN</small>
                          <span className="option-text">
                            {keepaData?.ean?.join(",")}
                          </span>
                        </li>
                        <li
                          className="option__kkp"
                          onClick={() =>
                            copyToClipboard(keepaData?.upc?.join(","))
                          }
                        >
                          <FeatherIcon icon={"copy"} />
                          <small>UPC</small>
                          <span className="option-text">
                            {keepaData?.upc?.join(",")}
                          </span>

                          <div className="srchh_div">
                            <Tooltip title={"Barcode Lookup"} placement="top">
                              <a
                                href={`https://www.barcodelookup.com/${keepaData?.upc?.[0]}`}
                                target="_blank"
                              >
                                <FeatherIcon icon={"link-2"} />
                              </a>
                            </Tooltip>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </OutsideAlerter>
                </div>
              </div>

              <div className="comparsion__body">
                <MainInfos
                  mainData={mainData}
                  keepaData={keepaData}
                  additionalData={additionalData}
                  targetOffersData={targetOffersData}
                  imageUrl={imageUrl}
                  noImg={NoImage}
                />

                <RoiFees
                  mainData={mainData}
                  targetOffersData={targetOffersData}
                />

                <KepickerCalculator
                  mainData={mainData}
                  setBasePrice={setBasePrice}
                  setTargetPrice={setTargetPrice}
                  setShippingCost={setShippingCost}
                  basePrice={basePrice}
                  targetPrice={targetPrice}
                  shippingCost={shippingCost}
                  reset={getData}
                />

                <DimensionsInfos additionalData={additionalData} />

                <div className="nav sheets_nav">
                  <button
                    className={`nav__link cursorp ${
                      isTab === "mc" ? " active" : " "
                    }`}
                    onClick={() => setTab("mc")}
                  >
                    {translate("Market Comparison")}
                  </button>
                  <button
                    className={`nav__link cursorp ${
                      isTab === "sf" ? " active" : " "
                    }`}
                    onClick={() => setTab("sf")}
                  >
                    {translate("Stock Fetcher")}
                  </button>
                  <button
                    className={`nav__link cursorp ${
                      isTab === "ai" ? " active" : " "
                    }`}
                    onClick={() => setTab("ai")}
                  >
                    {translate("Additional Infos")}
                  </button>
                  <button
                    className={`nav__link cursorp ${
                      isTab === "kd" ? " active" : " "
                    }`}
                    onClick={() => setTab("kd")}
                  >
                    {translate("Keepa Data")}
                  </button>
                </div>

                {isTab === "mc" ? (
                  <MarketComparison
                    setAsinFetcher={setAsinFetcher}
                    baseOffersData={baseOffersData}
                    targetOffersData={targetOffersData}
                    setBasePriceNotConverted={setBasePriceNotConverted}
                    basePriceNotConverted={basePriceNotConverted}
                    preferenceData={preferenceData}
                    asin={asin}
                    mainData={mainData}
                  />
                ) : (
                  <></>
                )}
                {isTab === "sf" ? (
                  <StockFetcher
                    setAsinFetcher={setAsinFetcher}
                    asin={asin}
                    domain={preferenceData?.target_domain}
                  />
                ) : (
                  <></>
                )}
                {isTab === "ai" ? (
                  <AdditionalInfos additionalData={additionalData} />
                ) : (
                  <></>
                )}
                {isTab === "kd" ? <KeepaData keepaData={keepaData} /> : <></>}

                <AsinFetcher
                  setAsinFetcher={setAsinFetcher}
                  isAsinFetcher={isAsinFetcher}
                />

                {/* <div className="product__cards_info">
                  <div className="cards_info_item gg">
                    <img src="/assets/img/icons8-warehouse-488.png"></img>
                    <div className="cards_info_actns">
                      <h4>Seller's Stock Fetcher</h4>
                      <button className="button-stroke button-small activity__button js-activity-button cc link">
                        <span>
                          Show
                          <FeatherIcon icon={"plus"} />
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="cards_info_item pp">
                    <img src="/assets/img/icons8-product-488.png"></img>
                    <div className="cards_info_actns">
                      <h4>Additional Product Infos</h4>
                      <button className="button-stroke button-small activity__button js-activity-button cc link">
                        <span>
                          Show
                          <FeatherIcon icon={"plus"} />
                        </span>
                      </button>
                    </div>
                  </div>
                  <div className="cards_info_item bb">
                    <img src="/assets/img/icons8-history-488.png"></img>
                    <div className="cards_info_actns">
                      <h4>Historical Data (Keepa)</h4>
                      <button className="button-stroke button-small activity__button js-activity-button cc link">
                        <span>
                          Show
                          <FeatherIcon icon={"plus"} />
                        </span>
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PBIPage;
